/*
 * KAITO – automatikus termék-adatlap (PDF) generátor.
 * Bemenet: window.KX_DS adat (a templates/product.datenblatt.liquid állítja elő a termék metafieldjeiből),
 * kimenet: pdfmake dokumentum-definíció (vektoros, kereshető szöveg, A4).
 * Használat: kxDatasheet.build(data, assets) → docDefinition
 * v51: Energia- és fényforrás-adatok szakasz (d.ls, EU 2019/2015 + 2019/2020) és gyártó (d.mfr, GPSR) – csak kitöltött adatokkal.
 * v54: További adatok szakasz (d.extra) – a részletes specifikációs lista azon sorai, amelyek a Műszaki adatokban még nem szerepelnek
 *      (pl. kivágási méret, anyag, garancia, fényáram teljesítmény-/színhőmérséklet-lépcsőnként).
 *      Kettős IP-védettség (pl. „IP64/IP20”): a szövegben teljes érték, az ikonban egymás alatt mindkettő.
 * v75: pdfSafe() – a pdfmake Roboto betűkészletéből hiányzó karakterek cseréje CSAK a PDF-ben (a HTML oldal változatlan):
 *      nyilak (U+2190–21FF, 27F0–27FF, 2794–27BF, 2900–297F, 2B00–2BFF) → "-" (pl. T8→T5 → T8-T5), ✓/✔ → "+", ✕/✗ → "x",
 *      ‣ ⁃ ∙ ▪ ■ ● ◦ → •, U+2012 → "-", U+202F → nbsp, egyéb szimbólumok/emoji törölve. (–, —, •, „”, …, ±, ° a fontban megvan.)
 *      Forgalmazó (d.mfr.brand): Kaito-Hungary Kft. esetén a márka (pl. LANDLITE) is megjelenik.
 */
(function (root) {
  'use strict';

  var C = { ink: '#1C1B1A', muted: '#6B655D', line: '#E6E1D8', soft: '#F4F1EC', zebra: '#FAF8F4', orange: '#EE5524', orangeDark: '#C4441A', curBg: '#FFF1EA' };

  var T = {
    hu: {
      sheet: 'Termékadatlap', type: 'Típus', sku: 'Cikkszám', ean: 'EAN', desc: 'Leírás', tech: 'Műszaki adatok',
      series: function (n) { return n + ' sorozat'; }, created: 'Az adatlap készült', page: 'Oldal',
      note: 'A műszaki változtatás jogát fenntartjuk. A fényáram és a teljesítmény tűrése ±10 %.',
      yes: 'igen', no: 'nem', more: 'További információ és rendelés',
      L: { w: 'Teljesítmény', v: 'Névleges feszültség', k: 'Színhőmérséklet', lm: 'Fényáram', eff: 'Fényhasznosítás', cri: 'Színvisszaadás (Ra)', ang: 'Sugárzási szög', ugr: 'Káprázási index (UGR)', ip: 'Védettség', ik: 'Ütésállóság', pc: 'Érintésvédelmi osztály', dim: 'Dimmelhető', tmp: 'Környezeti hőmérséklet', life: 'Élettartam', cap: 'Foglalat', eek: 'Energiahatékonysági osztály', eprel: 'EPREL regisztrációs szám', size: 'Méretek' }
    },
    de: {
      sheet: 'Datenblatt', type: 'Typ', sku: 'Art.-Nr.', ean: 'EAN', desc: 'Beschreibung', tech: 'Technische Daten',
      series: function (n) { return 'Serie ' + n; }, created: 'Datenblatt erstellt am', page: 'Seite',
      note: 'Technische Änderungen vorbehalten. Toleranz von Lichtstrom und Leistung ±10 %.',
      yes: 'ja', no: 'nein', more: 'Weitere Informationen und Bestellung',
      L: { w: 'Leistung', v: 'Nennspannung', k: 'Farbtemperatur', lm: 'Lichtstrom', eff: 'Lichtausbeute', cri: 'Farbwiedergabe (Ra)', ang: 'Abstrahlwinkel', ugr: 'Blendungsbewertung (UGR)', ip: 'Schutzart', ik: 'Stoßfestigkeit', pc: 'Schutzklasse', dim: 'Dimmbar', tmp: 'Umgebungstemperatur', life: 'Lebensdauer', cap: 'Sockel', eek: 'Energieeffizienzklasse', eprel: 'EPREL-Registriernummer', size: 'Abmessungen' }
    },
    en: {
      sheet: 'Datasheet', type: 'Type', sku: 'Item no.', ean: 'EAN', desc: 'Description', tech: 'Technical data',
      series: function (n) { return n + ' series'; }, created: 'Datasheet generated on', page: 'Page',
      note: 'Subject to technical changes. Tolerance of luminous flux and power ±10 %.',
      yes: 'yes', no: 'no', more: 'More information and ordering',
      L: { w: 'Power', v: 'Rated voltage', k: 'Colour temperature', lm: 'Luminous flux', eff: 'Luminous efficacy', cri: 'Colour rendering (Ra)', ang: 'Beam angle', ugr: 'Glare rating (UGR)', ip: 'Ingress protection', ik: 'Impact rating', pc: 'Protection class', dim: 'Dimmable', tmp: 'Ambient temperature', life: 'Rated life', cap: 'Base', eek: 'Energy efficiency class', eprel: 'EPREL registration no.', size: 'Dimensions' }
    }
  };

  var EEK = { A: '#009640', B: '#52AE32', C: '#C8D400', D: '#FFED00', E: '#FBBA00', F: '#EB6909', G: '#E30613' };
  var ORDER = ['w', 'v', 'k', 'lm', 'eff', 'cri', 'ang', 'ugr', 'ip', 'ik', 'pc', 'dim', 'tmp', 'life', 'cap', 'eek', 'eprel', 'size'];

  function blank(v) { return v === null || v === undefined || (typeof v === 'string' && v.trim() === ''); }
  // v75: glyphs missing from pdfmake's bundled Roboto (vfs_fonts) -> PDF-safe replacements
  var RX_ARROW = /[\u2190-\u21FF\u27F0-\u27FF\u2794-\u27BF\u2900-\u297F\u2B00-\u2BFF]/g;
  function pdfSafe(s) {
    if (typeof s !== 'string') return s;
    return s.replace(RX_ARROW, '-')
      .replace(/\u2012/g, '-')
      .replace(/[\u2713\u2714\u2705]/g, '+')
      .replace(/[\u2715-\u2718\u274C]/g, 'x')
      .replace(/[\u2023\u2043\u2219\u25A0\u25AA\u25CF\u25E6]/g, '\u2022')
      .replace(/\u202F/g, '\u00A0')
      .replace(/[\u2600-\u27BF]/g, '')
      .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      .replace(/[\uFE0E\uFE0F\u200D]/g, '');
  }
  var SKIP = { svg: 1, image: 1, link: 1, canvas: 1, layout: 1, widths: 1 };
  function sanitize(n) {
    if (typeof n === 'string') return pdfSafe(n);
    if (Array.isArray(n)) { for (var i = 0; i < n.length; i++) n[i] = sanitize(n[i]); return n; }
    if (n && typeof n === 'object') {
      for (var k in n) { if (Object.prototype.hasOwnProperty.call(n, k) && !SKIP[k] && typeof n[k] !== 'function') n[k] = sanitize(n[k]); }
    }
    return n;
  }
  function nf(lc) { return new Intl.NumberFormat(lc === 'hu' ? 'hu-HU' : lc === 'de' ? 'de-DE' : 'en-GB', { maximumFractionDigits: 1 }); }
  function num(lc, n) {
    var s = nf(lc).format(n).replace(/ /g, ' ');
    if (lc === 'hu' && Math.abs(n) < 10000) s = s.replace(/ /g, '');
    return s;
  }
  function svgPC(cls) {
    if (cls === 'I') return '<svg viewBox="0 0 32 32" width="30" height="30"><circle cx="16" cy="16" r="14" fill="none" stroke="#1C1B1A" stroke-width="1.8"/><path d="M16 6.5v11M9 17.5h14M11.5 21.5h9M14 25.5h4" stroke="#1C1B1A" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';
    if (cls === 'II') return '<svg viewBox="0 0 32 32" width="30" height="30"><rect x="3" y="3" width="26" height="26" fill="none" stroke="#1C1B1A" stroke-width="1.8"/><rect x="9.5" y="9.5" width="13" height="13" fill="none" stroke="#1C1B1A" stroke-width="1.8"/></svg>';
    if (cls === 'III') return '<svg viewBox="0 0 32 32" width="30" height="30"><path d="M16 2 30 16 16 30 2 16Z" fill="none" stroke="#1C1B1A" stroke-width="1.8" stroke-linejoin="round"/><path d="M11.5 11.5v9M16 11.5v9M20.5 11.5v9" stroke="#1C1B1A" stroke-width="1.8" stroke-linecap="round"/></svg>';
    return null;
  }
  function svgIP(ip) {
    var parts = String(ip).split(/\s*\/\s*/).filter(Boolean);
    if (parts.length > 1) {
      return '<svg viewBox="0 0 32 32" width="30" height="30"><circle cx="16" cy="16" r="14" fill="none" stroke="#1C1B1A" stroke-width="1.8"/>' +
        '<text x="16" y="14.6" text-anchor="middle" font-family="Helvetica" font-weight="bold" font-size="7" fill="#1C1B1A">' + parts[0] + '</text>' +
        '<text x="16" y="22.6" text-anchor="middle" font-family="Helvetica" font-weight="bold" font-size="7" fill="#6B655D">' + parts[1] + '</text></svg>';
    }
    return '<svg viewBox="0 0 32 32" width="30" height="30"><circle cx="16" cy="16" r="14" fill="none" stroke="#1C1B1A" stroke-width="1.8"/><text x="16" y="19.2" text-anchor="middle" font-family="Helvetica" font-weight="bold" font-size="8.6" fill="#1C1B1A">' + ip + '</text></svg>';
  }
  function svgCE() {
    return '<svg viewBox="0 0 44 32" width="40" height="30"><path d="M19 6.2A10 10 0 1 0 19 25.8" fill="none" stroke="#1C1B1A" stroke-width="3"/><path d="M39 6.2A10 10 0 1 0 39 25.8M27.5 16H37" fill="none" stroke="#1C1B1A" stroke-width="3"/></svg>';
  }
  function svgEEK(cls) {
    var c = EEK[cls]; if (!c) return null;
    var fg = (cls === 'C' || cls === 'D') ? '#1C1B1A' : '#FFFFFF';
    return '<svg viewBox="0 0 64 32" width="56" height="28"><rect x="1" y="1" width="12" height="30" fill="' + c + '" stroke="#1C1B1A" stroke-width="1"/>' +
      '<text x="7" y="10" text-anchor="middle" font-family="Helvetica" font-weight="bold" font-size="7" fill="' + fg + '">A</text>' +
      '<text x="7" y="28" text-anchor="middle" font-family="Helvetica" font-weight="bold" font-size="7" fill="' + fg + '">G</text>' +
      '<path d="M13 1H50L62 16 50 31H13Z" fill="' + c + '" stroke="#1C1B1A" stroke-width="1"/>' +
      '<text x="33" y="23.5" text-anchor="middle" font-family="Helvetica" font-weight="bold" font-size="20" fill="' + fg + '">' + cls + '</text></svg>';
  }

  function descNodes(html) {
    if (blank(html)) return [];
    var out = [], ul = null;
    var re = /<(p|li|h[1-6])[^>]*>([\s\S]*?)<\/\1>/gi, m, any = false;
    function txt(s) {
      return s.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'")
        .replace(/[ \t]+/g, ' ').trim();
    }
    while ((m = re.exec(html))) {
      any = true;
      var tag = m[1].toLowerCase(), t = txt(m[2]);
      if (!t) continue;
      if (tag === 'li') { if (!ul) { ul = { ul: [], margin: [0, 0, 0, 6], markerColor: C.orange }; out.push(ul); } ul.ul.push({ text: t, margin: [0, 1, 0, 1] }); }
      else { ul = null; out.push({ text: t, margin: [0, 0, 0, 6], bold: /^h/.test(tag) }); }
    }
    if (!any) { var t2 = txt(html); if (t2) out.push({ text: t2, margin: [0, 0, 0, 6] }); }
    return out.map(function (n) {
      if (n.ul && n.ul.length > 4) {
        var h = Math.ceil(n.ul.length / 2);
        return { columns: [{ ul: n.ul.slice(0, h), markerColor: C.orange }, { ul: n.ul.slice(h), markerColor: C.orange }], columnGap: 16, margin: n.margin };
      }
      return n;
    });
  }

  function specValues(d, lc, tr) {
    var s = d.specs || {}, v = {};
    if (s.w > 0) v.w = num(lc, s.w) + ' W';
    if (!blank(s.v)) v.v = s.v;
    if (!blank(s.k)) v.k = s.k;
    if (s.lm > 0) v.lm = num(lc, s.lm) + ' lm';
    if (s.lm > 0 && s.w > 0) v.eff = num(lc, Math.round(s.lm / s.w)) + ' lm/W';
    if (!blank(s.cri)) v.cri = 'Ra ' + s.cri;
    if (s.ang > 0) v.ang = s.ang + '°';
    if (!blank(s.ugr)) v.ugr = 'UGR ' + s.ugr;
    if (!blank(s.ip)) v.ip = String(s.ip).toUpperCase().replace(/\s*\/\s*/g, ' / ');
    if (!blank(s.ik)) v.ik = String(s.ik).toUpperCase();
    if (['I', 'II', 'III'].indexOf(s.pc) > -1) v.pc = s.pc;
    if (s.dim === true || s.dim === false) v.dim = s.dim ? tr.yes : tr.no;
    if (!blank(s.tmp)) v.tmp = s.tmp;
    if (s.life > 0) v.life = num(lc, s.life) + ' h';
    if (!blank(s.cap)) v.cap = s.cap;
    if (!blank(s.eek) && EEK[String(s.eek).toUpperCase()]) v.eek = String(s.eek).toUpperCase();
    if (!blank(d.eprel)) v.eprel = String(d.eprel);
    if (!blank(s.size)) v.size = /mm|cm/i.test(String(s.size)) ? String(s.size) : s.size + ' mm';
    return v;
  }

  function build(d, assets) {
    assets = assets || {};
    var lc = T[d.lc] ? d.lc : 'hu', tr = T[lc], s = d.specs || {}, V = specValues(d, lc, tr);
    var content = [];

    // Title block
    content.push({ text: tr.sheet.toUpperCase(), color: C.orange, bold: true, fontSize: 8.5, characterSpacing: 1.6, margin: [0, 0, 0, 4] });
    content.push({ text: d.title, fontSize: 16, bold: true, color: C.ink, lineHeight: 1.12, margin: [0, 0, 0, 6] });
    var ids = [];
    if (!blank(d.type)) ids.push({ text: [{ text: tr.type + ': ', color: C.muted }, { text: d.type, bold: true }] });
    if (!blank(d.sku)) ids.push({ text: [{ text: tr.sku + ': ', color: C.muted }, { text: d.sku, bold: true }] });
    if (!blank(d.ean)) ids.push({ text: [{ text: tr.ean + ': ', color: C.muted }, { text: d.ean, bold: true }] });
    if (ids.length) content.push({ columns: ids.map(function (x) { return Object.assign({ width: 'auto', margin: [0, 0, 18, 0] }, x); }), fontSize: 9.5, margin: [0, 0, 0, 12] });

    // Image + key figures
    var right = [];
    var keys = ['w', 'lm', 'k', 'ip'].filter(function (k) { return V[k]; });
    if (keys.length) {
      var cells = keys.map(function (k) {
        return { stack: [{ text: tr.L[k].toUpperCase(), fontSize: 6.8, bold: true, color: C.muted, characterSpacing: 0.6 }, { text: V[k], fontSize: 15, bold: true, color: C.ink, margin: [0, 3, 0, 0] }], fillColor: C.soft, margin: [8, 6, 6, 6] };
      });
      var rows = [];
      for (var i = 0; i < cells.length; i += 2) rows.push([cells[i], cells[i + 1] || { text: '', fillColor: '#FFFFFF' }]);
      right.push({ table: { widths: ['*', '*'], body: rows }, layout: { hLineWidth: function () { return 4; }, vLineWidth: function () { return 4; }, hLineColor: function () { return '#FFFFFF'; }, vLineColor: function () { return '#FFFFFF'; }, paddingLeft: function () { return 0; }, paddingRight: function () { return 0; }, paddingTop: function () { return 0; }, paddingBottom: function () { return 0; } }, margin: [-4, -4, -4, 8] });
    }
    var sym = [];
    var pcs = svgPC(s.pc); if (pcs) sym.push({ svg: pcs, width: 30 });
    if (V.ip) sym.push({ svg: svgIP(V.ip), width: 30 });
    if (d.has_ce) sym.push({ svg: svgCE(), width: 40 });
    if (V.eek) sym.push({ svg: svgEEK(V.eek), width: 56 });
    if (sym.length) right.push({ columns: sym.map(function (x) { return Object.assign({ width: 'auto', margin: [0, 0, 12, 0] }, x); }), margin: [0, 4, 0, 0] });

    var imgCol = assets.img ? { image: assets.img, fit: [215, 150], alignment: 'center' } : { text: '' };
    content.push({ columns: [{ width: 225, stack: [imgCol] }, { width: '*', stack: right }], columnGap: 18, margin: [0, 0, 0, 10] });

    // Description
    var dn = descNodes(d.desc_html);
    if (dn.length) {
      content.push(sectionHead(tr.desc));
      content.push({ stack: dn, fontSize: 9.3, lineHeight: 1.2, color: '#3D3A36', margin: [0, 0, 0, 4] });
    }

    // Technical data
    var pairs = ORDER.filter(function (k) { return V[k]; }).map(function (k) {
      var val = V[k], cell;
      if (k === 'pc' && pcs) cell = { columns: [{ svg: pcs.replace(/width="30" height="30"/, 'width="12" height="12"'), width: 12 }, { text: val, width: 'auto', margin: [5, 0, 0, 0] }] };
      else if (k === 'eek') cell = { columns: [{ svg: svgEEK(val).replace(/width="56" height="28"/, 'width="32" height="16"'), width: 32 }] };
      else if (k === 'eprel') cell = { text: val, link: 'https://eprel.ec.europa.eu/qr/' + val, color: C.orangeDark };
      else cell = { text: val };
      return [{ text: tr.L[k], color: C.muted }, Object.assign({ bold: true }, cell)];
    });
    if (pairs.length) {
      var half = Math.ceil(pairs.length / 2), tb = [];
      for (var r = 0; r < half; r++) {
        var a1 = pairs[r], a2 = pairs[r + half] || [{ text: '' }, { text: '' }];
        var bg = r % 2 ? C.zebra : '#FFFFFF';
        tb.push([a1[0], a1[1], a2[0], a2[1]].map(function (c) { return Object.assign({ fillColor: bg }, c); }));
      }
      content.push(sectionHead(tr.tech));
      content.push({ table: { widths: [104, '*', 104, '*'], body: tb }, layout: kvLayout(), fontSize: 9, margin: [0, 0, 0, 12] });
    }

    // Additional data from the product's detailed specification list (only rows not already in Technical data)
    var STD = /(cikksz|part number|artikelnummer|^típus$|^type$|^typ$|teljesítmény|^power|leistung|feszültség|voltage|spannung|színhőm|colou?r temp|farbtemp|fényáram|luminous flux|lichtstrom|színvissza|colou?r render|farbwieder|sugárzási|beam|abstrahl|ugr|ip véd|ip rating|ip-schutz|védettség|schutzart|ingress|érintésvéd|védelmi oszt|protection class|schutzklasse|szabályoz|dimm|élettartam|lifetime|lebensdauer|foglalat|socket|sockel|^méretek|^dimensions|^abmessungen|energiaoszt|energy class|energieeffizienz)/i;
    var MULTI = /(teljesítmény|power|leistung|színhőm|colou?r temp|farbtemp|fényáram|luminous|lichtstrom|ip véd|ip rating|ip-schutz)/i;
    var KEEP = /(kivágás|cut-out|cutout|einbauöffnung|deckenausschnitt)/i;
    var exr = (Array.isArray(d.extra) ? d.extra : []).filter(function (x) {
      if (!x || blank(x.name) || blank(String(x.value == null ? '' : x.value))) return false;
      var n = String(x.name), v = String(x.value);
      if (KEEP.test(n)) return true;
      if (STD.test(n) && !(MULTI.test(n) && v.indexOf('/') > -1)) return false;
      return true;
    }).slice(0, 30);
    if (exr.length) {
      var eh = Math.ceil(exr.length / 2), eb = [];
      for (var e = 0; e < eh; e++) {
        var x1 = exr[e], x2 = exr[e + eh];
        var bg4 = e % 2 ? C.zebra : '#FFFFFF';
        eb.push([{ text: String(x1.name), color: C.muted }, { text: String(x1.value), bold: true }, { text: x2 ? String(x2.name) : '', color: C.muted }, { text: x2 ? String(x2.value) : '', bold: true }].map(function (c) { return Object.assign({ fillColor: bg4 }, c); }));
      }
      content.push({ unbreakable: eb.length < 12, stack: [sectionHead(d.extra_title || 'More'), { table: { widths: [104, '*', 104, '*'], body: eb }, layout: kvLayout(), fontSize: 9, margin: [0, 0, 0, 12] }] });
    }

    // Energy and light source data (EU 2019/2015 + 2019/2020) – only filled fields
    var lsr = (d.ls && d.ls.rows) ? d.ls.rows.filter(function (x) { return x && !blank(x[0]) && !blank(String(x[1])); }) : [];
    if (lsr.length) {
      var lsShort = [], lsLong = [];
      lsr.forEach(function (x) { if (String(x[1]).length > 38) lsLong.push(x); else lsShort.push(x); });
      var lb = [], lh = Math.ceil(lsShort.length / 2);
      for (var q = 0; q < lh; q++) {
        var b1 = lsShort[q], b2 = lsShort[q + lh] || ['', ''];
        var bg2 = q % 2 ? C.zebra : '#FFFFFF';
        lb.push([{ text: b1[0], color: C.muted }, { text: String(b1[1]), bold: true }, { text: b2[0], color: C.muted }, { text: String(b2[1]), bold: true }].map(function (c) { return Object.assign({ fillColor: bg2 }, c); }));
      }
      lsLong.forEach(function (x, j) {
        var bg3 = (lh + j) % 2 ? C.zebra : '#FFFFFF';
        lb.push([{ text: x[0], color: C.muted, fillColor: bg3 }, { text: String(x[1]), colSpan: 3, fillColor: bg3 }, {}, {}]);
      });
      var lsHead = sectionHead(d.ls.title || 'EU');
      if (!blank(d.ls.sub)) lsHead.stack.splice(1, 0, { text: d.ls.sub, fontSize: 7.5, color: C.muted, margin: [0, 1, 0, 0] });
      content.push({ unbreakable: lb.length < 14, stack: [lsHead, { table: { widths: [104, '*', 104, '*'], body: lb }, layout: kvLayout(), fontSize: 9, margin: [0, 0, 0, 12] }] });
    }

    // Series table
    var fam = d.family;
    if (fam && fam.rows && fam.rows.length > 1) {
      var cols = [['type', tr.type], ['sku', tr.sku], ['w', tr.L.w], ['lm', tr.L.lm], ['eff', 'lm/W'], ['k', tr.L.k], ['ip', 'IP']];
      var rowsV = fam.rows.map(function (r) {
        var o = { type: r.type, sku: r.sku, k: r.k, ip: blank(r.ip) ? r.ip : String(r.ip).toUpperCase().replace(/\s*\/\s*/g, ' / ') };
        if (r.w > 0) o.w = num(lc, r.w) + ' W';
        if (r.lm > 0) o.lm = num(lc, r.lm) + ' lm';
        if (r.lm > 0 && r.w > 0) o.eff = num(lc, Math.round(r.lm / r.w));
        o.cur = r.cur; return o;
      });
      cols = cols.filter(function (c) { return rowsV.some(function (o) { return !blank(o[c[0]]); }); });
      var body = [cols.map(function (c) { return { text: c[1].toUpperCase(), color: '#FFFFFF', fillColor: C.ink, bold: true, fontSize: 7, characterSpacing: 0.3, margin: [0, 1, 6, 0] }; })];
      rowsV.forEach(function (o, i) {
        var bg = o.cur ? C.curBg : (i % 2 ? C.zebra : '#FFFFFF');
        body.push(cols.map(function (c, j) { return { text: blank(o[c[0]]) ? '–' : o[c[0]], fillColor: bg, bold: o.cur || j === 0, color: blank(o[c[0]]) ? '#B5AFA6' : C.ink }; }));
      });
      content.push({ unbreakable: true, stack: [sectionHead(tr.series(fam.name || '')), { table: { headerRows: 1, widths: cols.map(function (c, j) { return j === cols.length - 1 ? '*' : 'auto'; }), body: body }, layout: kvLayout(true), fontSize: 9, margin: [0, 0, 0, 10] }] });
    }

    // Manufacturer / seller (GPSR, (EU) 2023/988)
    var mf = d.mfr;
    if (mf && !blank(mf.name)) {
      var mt = [{ text: (mf.label || '') + ': ', color: C.muted }, { text: mf.name, bold: true }];
      if (!blank(mf.addr)) mt.push({ text: '  ·  ' + String(mf.addr).replace(/\s*\n\s*/g, ', ') });
      if (!blank(mf.contact)) mt.push({ text: '  ·  ' + mf.contact });
      if (!blank(mf.brand)) mt.push({ text: '  ·  ' + (mf.brand_label || '') + ': ' }, { text: String(mf.brand), bold: true });
      content.push({ text: mt, fontSize: 8.5, margin: [0, 2, 0, 2] });
      if (!blank(mf.eu)) content.push({ text: [{ text: (mf.eu_label || '') + ': ', color: C.muted }, { text: String(mf.eu).replace(/\s*\n\s*/g, ', ') }], fontSize: 8.5, margin: [0, 0, 0, 2] });
    }

    if (!blank(d.url)) { var su = d.url.replace(/^https?:\/\//, '').replace(/\?.*$/, ''); if (su.length > 64) su = su.slice(0, 62) + '…'; content.push({ text: [{ text: tr.more + ': ', color: C.muted }, { text: su, link: d.url, color: C.orangeDark }], fontSize: 8.5, margin: [0, 2, 0, 0] }); }

    var co = d.company || {};
    var doc = {
      pageSize: 'A4',
      pageMargins: [40, 80, 40, 52],
      info: { title: tr.sheet + ' – ' + (d.type || d.sku || '') + ' – ' + d.title, author: co.name || 'Kaito-Hungary Kft.', subject: tr.sheet, creator: (co.web || 'kaito.hu') },
      defaultStyle: { font: 'Roboto', fontSize: 9.5, color: C.ink },
      header: function () {
        var logo = assets.logo ? { image: assets.logo, fit: [120, 30], width: 120 } : { text: 'KAITO', bold: true, fontSize: 20, color: C.orange, characterSpacing: 1, width: 120 };
        return { stack: [
          { columns: [logo, { width: '*', alignment: 'right', fontSize: 7.5, color: C.muted, lineHeight: 1.3, text: [
            { text: (co.name || 'Kaito-Hungary Kft.') + '\n', bold: true, color: C.ink },
            (co.address || '') + '\n',
            [co.phone, co.email, co.web].filter(Boolean).join('  ·  ')
          ] }] },
          { canvas: [{ type: 'rect', x: 0, y: 0, w: 515.28, h: 2.2, color: C.orange }], margin: [0, 9, 0, 0] }
        ], margin: [40, 28, 40, 0] };
      },
      footer: function (cur, total) {
        return { margin: [40, 18, 40, 0], stack: [
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515.28, y2: 0, lineWidth: 0.6, lineColor: C.line }] },
          { columns: [
            { width: '*', fontSize: 7, color: C.muted, lineHeight: 1.3, text: tr.created + ' ' + (d.date || '') + '  ·  ' + tr.note },
            { width: 'auto', fontSize: 7, color: C.muted, text: tr.page + ' ' + cur + '/' + total, margin: [12, 0, 0, 0] }
          ], margin: [0, 6, 0, 0] }
        ] };
      },
      content: content
    };
    // v75: PDF-only glyph sanitising (HTML page untouched)
    sanitize(doc.content); sanitize(doc.info);
    var hdr = doc.header, ftr = doc.footer;
    doc.header = function () { return sanitize(hdr.apply(this, arguments)); };
    doc.footer = function () { return sanitize(ftr.apply(this, arguments)); };
    return doc;

    function sectionHead(t) {
      return { stack: [
        { text: t.toUpperCase(), bold: true, fontSize: 8.5, characterSpacing: 1.4, color: C.ink },
        { canvas: [{ type: 'rect', x: 0, y: 0, w: 28, h: 2.2, color: C.orange }], margin: [0, 4, 0, 0] }
      ], margin: [0, 4, 0, 7] };
    }
    function kvLayout(head) {
      return {
        hLineWidth: function (i, node) { return (i === 0 || i === node.table.body.length) ? 0.6 : 0.4; },
        vLineWidth: function () { return 0; },
        hLineColor: function () { return C.line; },
        paddingLeft: function () { return 8; }, paddingRight: function () { return 8; },
        paddingTop: function () { return 3.6; }, paddingBottom: function () { return 3.6; }
      };
    }
  }

  var api = { build: build, pdfSafe: pdfSafe };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.kxDatasheet = api;
})(this);
